import { combineReducers } from "redux";
import entities from "./entities";
import venue from "./venue";
import lunch from "./lunch";
import guests from "./guests";
import auth from "./auth";
import settings from "./settings";
import gifts from "./gifts";
import orders from "./orders";
import fullMenu from "./fullMenu";
import chats from "./chats";
import dashboard from "./dashboard";
import corpMenu from "./corpMenu";
import tags from "./tags";
import tagCategories from "./tagCategories";
import starsItems from "./starsItems";
import starsPromocodeAmount from "./starsPromocodeAmount";
import starsPromocode from "./starsPromocode";
import feedbacks from "./feedbacks";

import initialState from "./initialState";
import types from "../actionTypes";

const combinedReducer = combineReducers({
  entities,
  lunch,
  venue,
  guests,
  auth,
  settings,
  gifts,
  chats,
  orders,
  fullMenu,
  dashboard,
  corpMenu,
  tags,
  tagCategories,
  starsItems,
  starsPromocodeAmount,
  starsPromocode,
  feedbacks,
});

const rootReducer = (state, action) =>
  (action.type === types.LOGOUT ? initialState : combinedReducer(state, action));

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js